module.exports = __webpack_public_path__ + "static/media/emma-frost.d73cf965.png";